import { render } from "./AdminDashboard.vue?vue&type=template&id=6100a42e&scoped=true&ts=true"
import script from "./AdminDashboard.vue?vue&type=script&lang=ts"
export * from "./AdminDashboard.vue?vue&type=script&lang=ts"

import "./AdminDashboard.vue?vue&type=style&index=0&id=6100a42e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6100a42e"]])

export default __exports__